import {AbstractQueryBuilder, ExtractSortMap, IQueryMarkers} from '@global-data';
import {UserGroupsSortType} from '../types/user-group.types';

export interface IUserGroupsQueryMarkers extends IQueryMarkers {
	showLocked: boolean;
}

export class UserGroupsQueryBuilder extends AbstractQueryBuilder<IUserGroupsQueryMarkers, ExtractSortMap<typeof UserGroupsSortType>> {
	private static readonly defaults: IUserGroupsQueryMarkers = {
		searchText: '',
		sortBy: 'default',
		sortDesc: false,
		showLocked: true,
	};

	// sort by creation date
	protected readonly sortByMap = this.createSortByMap(UserGroupsSortType);

	public static create(): UserGroupsQueryBuilder {
		return new UserGroupsQueryBuilder();
	}

	private constructor() {
		super(UserGroupsQueryBuilder.defaults);
	}

	public setShowLocked(showLocked: boolean): this {
		return this.updateMarkers({showLocked});
	}

	protected override buildFixedParts(): string[] {
		return [];
	}
}
